import { mkShare, type Share, type ShareInput, type ShareProps } from './types';

export type ShareRequestData = Pick<
  ShareProps,
  | 'id'
  | 'clientId'
  | 'datasetId'
  | 'granteeFirstName'
  | 'granteeLastName'
  | 'granteeEmail'
  | 'permissions'
  | 'state'
  | 'testMode'
  | 'isDeleted'
>;

export type ShareResponseData = ShareProps & {
  grantorUsername?: string;
};

export type SharesResponse = {
  data?: {
    resources?: ShareResponseData[];
  };
} | null;

export function transformShareToRequestData(share: ShareInput): ShareRequestData {
  return {
    id: share.id,
    clientId: share.clientId,
    datasetId: share.datasetId,

    granteeFirstName: share.granteeFirstName,
    granteeLastName: share.granteeLastName,
    granteeEmail: share.granteeEmail,

    permissions: share.permissions,
    state: share.state,

    testMode: share.testMode,

    isDeleted: share.isDeleted,
  };
}

export function transformResponseToShares(response?: SharesResponse): Share[] {
  const resources = response?.data?.resources;
  if (!Array.isArray(resources)) {
    throw new TypeError('Expected a shares response containing a resources array');
  }

  return resources.map((data) =>
    mkShare({
      id: data.id,
      clientId: data.clientId,

      datasetId: data.datasetId,

      granteeFirstName: data.granteeFirstName,
      granteeLastName: data.granteeLastName,
      granteeEmail: data.granteeEmail,

      grantorFirstName: data.grantorFirstName,
      grantorLastName: data.grantorLastName,
      grantorEmail: data.grantorUsername,

      permissions: data.permissions,
      state: data.state,

      lastAccessedAt: data.lastAccessedAt,

      createdAt: data.createdAt,
      isDeleted: data.isDeleted,
    }),
  );
}
